/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'inferno-redux';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import PointIndicator from 'components/shared/pointindicator/pointindicator';



/* ========== ~~~~~~~~~~ REWARDS : POINT INDICATOR : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ settings, contentStatus, contentData, rewards, screenStatus}, { contentId }) => ({
	currentContentStatus: contentStatus[contentId],
    currentContentData: contentData[contentId].data[contentStatus[contentId].frame],
    currentContentSettings: settings.contentSettings[contentId],
    rewardsSettings: rewards.settings,
    rewardStatus: rewards.status,
    rewardsEnabled: rewards.settings.enabled,
    rewardsPermitted: rewards.status.rewardsPermitted,
    screenStatus
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
// will be utilized from any component that wants to incorporate "Content" component
export default connect(
  mapStateToProps
)(PointIndicator);
